import { TIPS_EVENTS, TIPS_DATA_SOURCE } from '@/packages/components/hook/useTips'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-goods-tips', // 组件名
  type: 'component-business', // 组件类型
  label: '物品提示', // 组件label
  icon: 'icon-xy-goods-tips', // 组件图标
  defaultWidth: 0, // 组件默认宽度
  defaultHeight: 0 // 组件默认高度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  backgroundSrc: { type: String, default: '' }, // 背景图片
  // 物品配置
  activityId: { type: String, default: '' } // 物品id
}

/**
 * 组件开放方法事件
 */
export const events = TIPS_EVENTS

/**
 * 组件开放数据源
 */
export const dataSource = TIPS_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-goods-tips' // 表单组件
  }
]
